import { DOCS_URL } from "../../../config/constants.js";
import EditorialText from "./EditorialText.svelte";

export default {
    component: EditorialText,
    name: "Editorial Text",
    description: "Rich text editor for blog post content. Use formatting sparingly.",
    docsLink: `${DOCS_URL}/storybook/?path=/story/atoms-editorialtext--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/file-text.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2Fb6c6440908264ab1b0037f7f05d82420",
    inputs: [
        {
            name: "content",
            type: "richText",
            friendlyName: "Editorial body copy",
            helperText:
                "Please use formatting sparingly. Recommended: headings (H2-H3), bold, italic, lists, and quotes.",
        },
    ],
};
